
define('text!templates/appMain/privilegedMain/qm/policies/editors/listedItemsEditor.html',[],function () { return '<!-- ko foreach: $parent.listedItems -->\n<div class="item-name-container">\n    <span class="fa fa-times-circle" data-bind="click: $data.removeItem().bind($index)"></span>\n    <span class="item-name&quot;" data-bind="text: names"></span>\n</div>\n<!-- /ko -->';});

